<mat-card>
  <h2 translate>ecommerce.title</h2>
  <p translate>ecommerce.subtitle</p>
  <form [formGroup]="ecommerceForm" (ngSubmit)="consult()">
    <mat-grid-list cols="15" rowHeight="10px">
      <mat-grid-tile colspan="5" rowspan="6">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>ecommerce.numOperation</mat-label>
          <input
            id="numOperation"
            formControlName="numOperation"
            matInput
            type="text"
            maxlength="30"
            autocomplete="off"
          />
        </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile colspan="5" rowspan="6">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>ecommerce.nif</mat-label>
          <input id="nif" formControlName="nif" matInput type="text" maxlength="30" autocomplete="off" />
        </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile colspan="5" rowspan="6">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>ecommerce.id</mat-label>
          <input id="guid" formControlName="guid" matInput type="text" maxlength="30" autocomplete="off" />
        </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile colspan="5" rowspan="6">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>ecommerce.name</mat-label>
          <input id="name" formControlName="name" matInput type="text" maxlength="30" autocomplete="off" />
        </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile colspan="5" rowspan="6">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>ecommerce.firstName</mat-label>
          <input id="fisrtname" formControlName="firstName" matInput type="text" maxlength="30" autocomplete="off" />
        </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile colspan="5" rowspan="6">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>ecommerce.lastName</mat-label>
          <input id="lastname" formControlName="lastName" matInput type="text" maxlength="30" autocomplete="off" />
        </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile colspan="8" rowspan="6">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>ecommerce.guidOperation</mat-label>
          <input id="lastname" formControlName="guid" matInput type="text" maxlength="30" autocomplete="off" />
        </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile colspan="7" rowspan="6"> </mat-grid-tile>
      <mat-grid-tile colspan="5" rowspan="6">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>ecommerce.dateInit</mat-label>
          <input
            id="dateInit"
            formControlName="initialDate"
            matInput
            [matDatepicker]="dateInit"
            [max]="maxDate"
            autocomplete="off"
          />
          <mat-datepicker-toggle matSuffix [for]="dateInit"></mat-datepicker-toggle>
          <mat-datepicker #dateInit></mat-datepicker>
          <mat-error *ngIf="ecommerceForm.controls.initialDate.hasError('required')" translate>
            field.required
          </mat-error>
          <mat-error *ngIf="ecommerceForm.errors?.dateInvalid" translate>field.error.dateInitial</mat-error>
        </mat-form-field>
      </mat-grid-tile>

      <mat-grid-tile colspan="5" rowspan="6">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>ecommerce.dateEnd</mat-label>
          <input
            id="dateEnd"
            formControlName="finalDate"
            matInput
            [matDatepicker]="dateEnd"
            [max]="maxFinalDate"
            [min]="minDate"
            autocomplete="off"
          />
          <mat-datepicker-toggle matSuffix [for]="dateEnd"></mat-datepicker-toggle>
          <mat-datepicker #dateEnd></mat-datepicker>
          <mat-error *ngIf="ecommerceForm.errors?.dateInvalid" translate>field.error.dateFinal</mat-error>
          <mat-error *ngIf="ecommerceForm.controls.finalDate.hasError('required')" translate>
            field.required
          </mat-error>
          <mat-error *ngIf="ecommerceForm.controls.finalDate.hasError('matDatepickerMax')" translate>
            field.notMoreThanAYear
          </mat-error>
        </mat-form-field>
      </mat-grid-tile>

      <mat-grid-tile colspan="5" rowspan="6">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>ecommerce.dateUpdate</mat-label>
          <input
            id="dateUpdate"
            formControlName="dateUpdate"
            matInput
            [max]="maxDate"
            [matDatepicker]="dateUpdate"
            autocomplete="off"
          />
          <mat-datepicker-toggle matSuffix [for]="dateUpdate"></mat-datepicker-toggle>
          <mat-datepicker #dateUpdate></mat-datepicker>
          <mat-error *ngIf="ecommerceForm.controls.dateUpdate.hasError('required')" translate>
            field.required
          </mat-error>
        </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile colspan="15" rowspan="6">
        <div fxFlex="100" class="btn">
          <button
            id="sendButtonRequest"
            type="submit"
            mat-flat-button
            color="accent"
            [disabled]="ecommerceForm.invalid"
          >
            {{ 'ecommerce.consult' | translate | uppercase }}
          </button>
        </div>
      </mat-grid-tile>
    </mat-grid-list>
  </form>
</mat-card>

<mat-card *ngIf="hasCalledOnce">
  <h2 translate>ecommerce.dataOperations</h2>
  <mat-card-content>
    <div class="table__wrapper">
      <table
        aria-label="ecommerce"
        mat-table
        [dataSource]="dataSource"
        *ngIf="dataSource.data?.length > 0; else noResults"
      >
        <ng-container matColumnDef="idEcommerce">
          <th mat-header-cell *matHeaderCellDef translate>ecommerce.id</th>
          <td mat-cell *matCellDef="let element">{{ element.idEcommerce }}</td>
        </ng-container>
        <ng-container matColumnDef="guidOperation">
          <th mat-header-cell *matHeaderCellDef translate>ecommerce.guidOperation</th>
          <td mat-cell *matCellDef="let element">
            <mat-label class="ecommerce__link" (click)="getDetailEcommerce(element)">{{ element.guid }}</mat-label>
          </td>
        </ng-container>
        <ng-container matColumnDef="numOperation">
          <th mat-header-cell *matHeaderCellDef translate>ecommerce.numRequest</th>
          <td mat-cell *matCellDef="let element">{{ element.numOperacion }}</td>
        </ng-container>
        <ng-container matColumnDef="codeTPV">
          <th mat-header-cell *matHeaderCellDef translate>ecommerce.codeTPV</th>
          <td mat-cell *matCellDef="let element">
            <mat-label class="ecommerce__link" (click)="getDetailEcommerceTPV(element)"
              >{{ element.codStateTpv }}
            </mat-label>
          </td>
        </ng-container>
        <ng-container matColumnDef="reference">
          <th mat-header-cell *matHeaderCellDef translate>ecommerce.reference</th>
          <td mat-cell *matCellDef="let element">{{ element.orderReference }}</td>
        </ng-container>
        <ng-container matColumnDef="guidLogaltyCheck">
          <th mat-header-cell *matHeaderCellDef translate>ecommerce.statusLogaltyCheck</th>
          <td mat-cell *matCellDef="let element">
            <mat-label class="ecommerce__link" (click)="getDetailDigitalSignature(element)"
              >{{ element.guidCheckLgty }}
            </mat-label>
          </td>
        </ng-container>
        <ng-container matColumnDef="guidLogaltyContract">
          <th mat-header-cell *matHeaderCellDef translate>ecommerce.statusLogaltyContract</th>
          <td mat-cell *matCellDef="let element">
            <mat-label class="ecommerce__link" (click)="getDetailDigitalSignature(element)"
              >{{ element.guidContract }}
            </mat-label>
          </td>
        </ng-container>
        <ng-container matColumnDef="owner">
          <th mat-header-cell *matHeaderCellDef translate>ecommerce.owner</th>
          <td mat-cell *matCellDef="let element">
            {{ element.name + ' ' + element.lastname1 + ' ' + element.lastname2 }}
          </td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef translate>ecommerce.status</th>
          <td mat-cell *matCellDef="let element">{{ element.stateProcess }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>

    <mat-paginator *ngIf="dataSource.data.length > 15" hidePageSize [pageSize]="15" showFirstLastButtons>
    </mat-paginator>

    <ng-template #noResults>
      <div fxLayout="column" fxLayoutAlign="center center">
        <mat-label class="panel-request__label-no-operation" translate>request.noOperations</mat-label>
      </div>
    </ng-template>
  </mat-card-content>
</mat-card>

<div *ngIf="hasCalledOnce" class="panel_footer__buttons">
  <div fxFlex="100" fxLayoutAlign="end start" fxLayoutGap="16px">
    <button
      id="createAllExcelPanel"
      mat-stroked-button
      color="accent"
      (click)="createExcel()"
      [disabled]="dataSource.data?.length === 0"
    >
      <mat-icon class="icon-ic_file_download"></mat-icon>
      <span>{{ 'request.button.excel' | translate | uppercase }}</span>
    </button>
    <button
      id="createAllPdfPanel"
      mat-stroked-button
      color="accent"
      (click)="createPdf()"
      [disabled]="dataSource.data?.length === 0"
    >
      <mat-icon class="icon-ic_print"></mat-icon>
      <span>{{ 'request.button.print' | translate | uppercase }}</span>
    </button>
  </div>
</div>
